module.exports = __webpack_public_path__ + "static/media/companyLogo.d2a228e1.svg";